export default __webpack_public_path__ + "static/image13-eaf1b99940a8c966770219444b978d24.jpg";